//Making sure Snipcart is ready
document.addEventListener("snipcart.ready", function () {
  //Subscribing to different events
  Snipcart.events.on("item.added", function (item) {
    itemAdded(item);
  });

  Snipcart.events.on("item.removed", function (item) {
    itemRemoved(item);
  });

  Snipcart.events.on("cart.confirmed", function (state) {
    orderCompleted(state);
  });
});

function push(params) {
  // Google Tag Manager
  if (typeof dataLayer !== "undefined") {
    dataLayer.push(params);
  }

  // Matomo
  window._mtm = window._mtm || [];
  window._mtm.push(params);
}

function createProductsFromItems(items) {
  return items.map(function (item) {
    if (item.categories.length > 0) {
      var category = item.categories[0];
    }

    return {
      item_name: item.name,
      item_variant: item.description,
      item_id: item.id,
      price: item.price,
      item_category: category,
      quantity: item.quantity,
    };
  });
}

function itemAdded(item) {
  push({
    event: "add_to_cart",
    ecommerce: {
      items: createProductsFromItems([item]),
      value: item.price,
    },
  });
}

function itemRemoved(item) {
  push({
    event: "remove_from_cart",
    ecommerce: {
      items: createProductsFromItems([item]),
      value: item.price,
    },
  });
}

function orderCompleted(order) {
  var items = createProductsFromItems(order.items.items);
  var ids = items.map((item) => item.item_id);
  var prices = items.map((item) => item.price);

  push({
    event: "purchase",
    ecommerce: {
      transaction_id: order.token,
      affiliation: "Website",
      value: order.total,
      currency: "EUR",
      item_ids: ids,
      item_prices: prices,
      items: items,
    },
  });
}
